import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work Experience"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./auxiliobits_logo.jpg"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Auxiliobits Technologies pvt ltd</div>
							<div className="work-subtitle">
								SOFTWARE ENGINEER INTERN
							</div>
							<div className="work-duration">Jan - Feb 2025</div>
						</div>

						<div className="work">
							<img
								src="./logo1.avif"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">Nugen IT Services pvt ltd</div>
							<div className="work-subtitle">
								MERN STACK DEVELOPER INTERN
							</div>
							<div className="work-duration">March - Oct 2025</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
